<template>
    <div>
        <div class="content-dashboard">
            <div class="title">회원 가입/탈퇴 현황</div>
            <div class="chart-select-common">
                <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="~"
                  @change="getList"
                />
            </div>
            <div class="chart-common" id="InoutChart"></div>
        </div>
    </div>
</template>


<script>
import util from "@/mixins/util";
import * as echarts from "echarts";
import dateMixins from "@/mixins/dateMixins";
export default {
    name: "DashboardMemberInoutLayout",
    mixins: [dateMixins],
    components: {},
    props: {},
    data() {
        return {
            Chart: null,
            dateRange : [new Date(),new Date()],
            joinMemberList :[],
            outMemberList :[],
            option : {},
        };
    },
    beforeRouterEnter() {},
    created() {
        this.getList();
    },
    mounted() {
    },
    beforeUnmount() {},
    unmounted() {},
    computed: {},
    methods: {
        getList() {
            let params ={};
            params.crsd = this.returnDateFormat(this.dateRange[0],"YYYY-MM-DD");
            params.cred = this.returnDateFormat(this.dateRange[1],"YYYY-MM-DD");
            this.$api.$dash.getMemberPeriodList(params).then(data => data.Data.Result).then(res => {
                if (res.Info.status) {
                    this.dashData = res.List;
                } else {
                    this.dashData = [];
                }
                this.setData();
            })
        },
        setData() {
            this.joinMemberList = [];
            this.outMemberList = [];
            let startDate = this.dateRange[0];
            let lastDate = this.dateRange[1];
            let dateKeyList = [];
            while (startDate <= lastDate) {
                let dateKey = this.returnDateFormat(startDate,"YY.MM.DD");
                dateKeyList.push(this.returnDateFormat(startDate,"YY.MM.DD"));
                if(!util.isEmpty(this.dashData[dateKey])){
                    this.joinMemberList.push(this.dashData[dateKey].JoinCnt);
                    this.outMemberList.push(this.dashData[dateKey].OutCnt);
                }else {
                    this.joinMemberList.push(0);
                    this.outMemberList.push(0);
                }

                startDate.setDate(startDate.getDate() + 1);
            }  
            let options = {
                legend: {
                    bottom:0,
                },
                tooltip: {},
                xAxis: {
                    type: "category",
                    data: dateKeyList,
                },
                yAxis: {
                    type: "value",
                },
                series: [
                    {
                        name: '신규회원',
                        itemStyle: {
                            color: "blue",
                        },
                        data: this.joinMemberList,
                        type: "bar",
                    },
                    {
                        name: '탈퇴회원',
                        itemStyle: {
                            color: "red",
                        },
                        data: this.outMemberList,
                        type: "bar",
                    },
                ],
            }
            this.setChart(options);
        },
        setChart(options) {
            let chartDom = document.getElementById("InoutChart");
            this.Chart = echarts.init(chartDom, null, {});
            this.Chart.clear();
            this.Chart.setOption(options);
        },
        // chartClear() {
        //     this.Chart.clear();
        //     this.Chart.setOption(this.option);
        // }
    },
    watch: {},
};
</script>
